import { useState } from "react";
import { Alert, Button, Card, Form, Input, Typography } from "antd";

import { api } from "../api";

export default function Login({ onSuccess }: { onSuccess: () => void }) {
  const [error, setError] = useState("");
  const [needTOTP, setNeedTOTP] = useState(false);
  const [busy, setBusy] = useState(false);

  async function submit(values: { login: string; password: string; totp?: string }) {
    setBusy(true);
    setError("");
    try {
      await api.login(values.login, values.password, values.totp ?? "");
      onSuccess();
    } catch (e: any) {
      // Требование второго фактора — не ошибка ввода, а следующий шаг.
      if (String(e.message).includes("второго фактора")) {
        setNeedTOTP(true);
      }
      setError(e.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-page">
      <div className="login-page__intro">
        <div className="login-page__mark">W</div>
        <div className="login-page__eyebrow">Портфельное управление</div>
        <Typography.Title>WAVIoT PLAN</Typography.Title>
        <Typography.Paragraph>Рабочая среда для контроля портфеля, поручений и исполнения.</Typography.Paragraph>
      </div>
      <Card className="login-page__card">
        <div className="login-page__card-heading"><Typography.Text>Защищённый доступ</Typography.Text><Typography.Title level={3}>Вход в систему</Typography.Title></div>
        <Form layout="vertical" onFinish={submit} autoComplete="off">
          <Form.Item name="login" label="Логин" rules={[{ required: true, message: "Введите логин" }]}>
            <Input autoFocus />
          </Form.Item>
          <Form.Item name="password" label="Пароль" rules={[{ required: true, message: "Введите пароль" }]}>
            <Input.Password />
          </Form.Item>
          {needTOTP && (
            <Form.Item name="totp" label="Код второго фактора" rules={[{ required: true, message: "Введите код" }]}>
              <Input placeholder="6 цифр" maxLength={6} autoFocus />
            </Form.Item>
          )}
          {error && <Alert type="error" message={error} style={{ marginBottom: 12 }} />}
          <Button type="primary" htmlType="submit" block loading={busy}>
            Войти
          </Button>
        </Form>
      </Card>
    </div>
  );
}
